module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-result', {
    attrs: {
      "type": _vm.showType.H5,
      "types": _vm.type
    }
  }, [(_vm.type == _vm.headType.recommendMain) ? _c('v-recommendHead') : (_vm.type == _vm.headType.searchResultHead) ? _c('v-searchHead', {
    attrs: {
      "type": _vm.headType.searchResultHead,
      "keywords": _vm.keyword
    }
  }) : _c('div', {
    staticClass: "header-all"
  }, [(_vm.type == _vm.headType.recommend) ? _c('v-classHead', {
    attrs: {
      "type": _vm.type,
      "title": _vm.title
    }
  }) : (_vm.type == _vm.headType.cidHead) ? _c('v-cidHead', {
    attrs: {
      "cid": _vm.cid
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.type == _vm.headType.recommend) ? _c('div', {
    staticStyle: {
      "height": "3rem"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == _vm.headType.cidHead) ? _c('div', {
    style: (_vm.cidHeadCss)
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8a28cd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecommendResult.vue
// module id = 217
// module chunks = 2